import React from 'react';
import { ThemeProvider } from 'styled-components';
import OImage from '../OImage';
import { Link } from 'gatsby';

import ButtonTertiary from '../ButtonTertiary';
import { Module, Container, Card } from './styles';
import Wrapper from '../../ui/Wrappers';
import { themes } from '../../ui/design-tokens';
import { getSrcset, externalLink } from '../../ui/helpers';

import barBabies from '../../images/bar-babies.png';
import barKids from '../../images/bar-kids.png';
import barTweens from '../../images/bar-tweens.png';
import barTeens from '../../images/bar-teens.png';
import barNeutral from '../../images/bar-neutral.png';

interface ICard {
  key?: string;
  title: string;
  text?: string;
  link: { uri?: string; title?: string };
  imageUrl: any;
  imageAlt?: string;
}

interface IProps {
  theme?: string;
  title: string;
  text?: string;
  cards: Array<ICard>;
}

const CrossSelling = ({ theme, title, text, cards }: IProps) => {
  const cleanedTheme = theme ? theme : 'white';

  const renderBar = eTheme => {
    switch (eTheme) {
      case 'babies':
        return (
          <OImage
            src={barBabies}
            className="bar"
            alt=""
            aspectRatio={340 / 57}
            aria-hidden="true"
          />
        );
      case 'kids':
        return (
          <OImage src={barKids} className="bar" alt="" aspectRatio={340 / 57} aria-hidden="true" />
        );
      case 'tweens':
        return (
          <OImage
            src={barTweens}
            className="bar"
            alt=""
            aspectRatio={340 / 57}
            aria-hidden="true"
          />
        );
      case 'teens':
        return (
          <OImage src={barTeens} className="bar" alt="" aspectRatio={340 / 57} aria-hidden="true" />
        );
      default:
        return (
          <OImage
            src={barNeutral}
            className="bar"
            alt=""
            aspectRatio={340 / 57}
            aria-hidden="true"
          />
        );
    }
  };

  return (
    <ThemeProvider theme={themes.basic[cleanedTheme]}>
      <Module>
        <Wrapper as={Module} size="mainwrapper">
          <Wrapper size="reader" style={{ textAlign: 'center' }}>
            {title && <div className="title">{title}</div>}
            {text && <p className="text">{text}</p>}
          </Wrapper>
          <Container>
            {cards.map(card => (
              <Card
                key={card.key}
                data-gtm-action={`cross-selling_${card?.title}`}
                data-gtm-category="cta">
                <div className={'content'}>
                  {card.link?.uri ? (
                    externalLink(card.link?.uri) ? (
                      <a
                        href={card.link?.uri}
                        target={'_blank'}
                        rel="nofollow noopener noreferrer"
                        aria-label={`This image is a link to: ${card.link?.uri} (will be opened in a new window)`}
                        data-gtm-event
                        data-gtm-label={`${card.link?.title}_${
                          typeof window !== 'undefined' ? window.location.href : ''
                        }`}>
                        {card.imageUrl && (
                          <OImage
                            src={card.imageUrl.original?.href}
                            aspectRatio={
                              card.imageUrl.original?.meta.width /
                              card.imageUrl.original?.meta.height
                            }
                            srcSet={getSrcset(card.imageUrl)}
                            webp={getSrcset(card.imageUrl, true)}
                            className="image"
                            alt={card.imageAlt || ''}
                          />
                        )}
                      </a>
                    ) : (
                      <Link
                        to={card.link?.uri}
                        aria-label={`This image is a link to: ${card.link?.uri}`}
                        data-gtm-event
                        data-gtm-label={`${card.link?.title}_${
                          typeof window !== 'undefined' ? window.location.href : ''
                        }`}>
                        {card.imageUrl && (
                          <OImage
                            src={card.imageUrl.original?.href}
                            aspectRatio={
                              card.imageUrl.original?.meta.width /
                              card.imageUrl.original?.meta.height
                            }
                            srcSet={getSrcset(card.imageUrl)}
                            webp={getSrcset(card.imageUrl, true)}
                            className="image"
                            alt={card.imageAlt || ''}
                          />
                        )}
                      </Link>
                    )
                  ) : (
                    card.imageUrl && (
                      <OImage
                        src={card.imageUrl.original?.href}
                        aspectRatio={
                          card.imageUrl.original?.meta.width / card.imageUrl.original?.meta.height
                        }
                        srcSet={getSrcset(card.imageUrl)}
                        webp={getSrcset(card.imageUrl, true)}
                        className="image"
                        alt={card.imageAlt || ''}
                      />
                    )
                  )}
                  {card.title && <h3 className="title">{card.title}</h3>}
                  {card.text && <p className="text">{card.text}</p>}
                  {card.link?.title && card.link?.uri && (
                    <ButtonTertiary
                      to={card.link?.uri}
                      target={`${externalLink(card.link?.uri) ? '_blank' : undefined}`}
                      label={card.link.title}
                      className="btn"
                      data-gtm-event
                      data-gtm-label={`${card.link?.title}_${
                        typeof window !== 'undefined' ? window.location.href : ''
                      }`}
                    />
                  )}
                </div>
              </Card>
            ))}
          </Container>
        </Wrapper>
      </Module>
    </ThemeProvider>
  );
};

export default CrossSelling;
